// imports


//-----------------------Inicia titulo para Fv-------------------------------
export const getTituloFv = (descripcionRamo, descripcionSeguro) =>{
  let titulo = '';
  // determinar titutlo
  if ( descripcionRamo === "VEHÍCULOS") { titulo = "VH";}
  else if ( descripcionRamo === "HOGAR") { titulo = "HOG";}
  else if ( descripcionRamo === "TRAVEL") {titulo = "TRV";}
  else if ( descripcionRamo === "RCANDINA") { titulo = "RCANDINA";}
  else if ( descripcionRamo === "PYMES") { titulo = "PYMES";}
  else if ( descripcionRamo === "ACCIDENTES PERSONALES") { titulo = "AP";}
  else if ( descripcionRamo === "LÍNEAS FINANCIERAS" && descripcionSeguro && descripcionSeguro === "CyberEdge Express") { titulo = "CYBER";}
  else if ( descripcionRamo === "LÍNEAS FINANCIERAS" && descripcionSeguro && descripcionSeguro === "D&O Express") { titulo = "DYO";}
  else if ( descripcionRamo === "LÍNEAS FINANCIERAS" && descripcionSeguro && descripcionSeguro === "Responsabilidad Civil Profesional") { titulo = "RCP";}
  else if ( descripcionRamo === "LÍNEAS FINANCIERAS" && descripcionSeguro && descripcionSeguro === "Responsabilidad Civil Profesional Para Instituciones Educativas") { titulo = "RCPIE";}
  else if ( descripcionRamo === "RESPONSABILIDAD CIVIL" && descripcionSeguro && descripcionSeguro === "RC GASOLINERAS") { titulo = "RCGAS";}
  else if ( descripcionRamo === "RESPONSABILIDAD CIVIL" && descripcionSeguro && descripcionSeguro === "RC GENERAL PREDIOS LABORES Y OPERACIONES") { titulo = "RCGENERAL";}

  // return
  return titulo;
}
//-----------------------Termina titulo para Fv-------------------------------